function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-687.000000, -379.000000)",
  fill: "#9B9B9B"
}, React.createElement("g", {
  transform: "translate(687.000000, 379.000000)"
}, React.createElement("polygon", {
  points: "4.26939655 5.39698276 5.16163793 5.39698276 5.16163793 12.5349138 4.26939655 12.5349138"
}), React.createElement("polygon", {
  points: "6.05387931 5.39698276 6.94612069 5.39698276 6.94612069 12.5349138 6.05387931 12.5349138"
}), React.createElement("polygon", {
  points: "7.83836207 5.39698276 8.73060345 5.39698276 8.73060345 12.5349138 7.83836207 12.5349138"
}), React.createElement("polygon", {
  points: "0.700431034 2.72025862 12.299569 2.72025862 12.299569 3.6125 0.700431034 3.6125"
}), React.createElement("path", {
  d: "M8.70086207,3.16637931 L7.86810345,3.16637931 L7.86810345,2.27413793 C7.86810345,2.00646552 7.65991379,1.79827586 7.39224138,1.79827586 L5.60775862,1.79827586 C5.34008621,1.79827586 5.13189655,2.00646552 5.13189655,2.27413793 L5.13189655,3.16637931 L4.29913793,3.16637931 L4.29913793,2.27413793 C4.29913793,1.56034483 4.89396552,0.965517241 5.60775862,0.965517241 L7.39224138,0.965517241 C8.10603448,0.965517241 8.70086207,1.56034483 8.70086207,2.27413793 L8.70086207,3.16637931"
}), React.createElement("path", {
  d: "M9.17672414,15.2116379 L3.82327586,15.2116379 C3.10948276,15.2116379 2.48491379,14.6168103 2.42543103,13.9030172 L1.59267241,3.19612069 L2.48491379,3.13663793 L3.31767241,13.8435345 C3.34741379,14.1112069 3.58534483,14.3193966 3.82327586,14.3193966 L9.17672414,14.3193966 C9.44439655,14.3193966 9.68232759,14.0814655 9.68232759,13.8435345 L10.5150862,3.13663793 L11.4073276,3.19612069 L10.574569,13.9030172 C10.5150862,14.6465517 9.89051724,15.2116379 9.17672414,15.2116379"
}))));

const SvgDeleteIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "13px",
  height: "16px",
  viewBox: "0 0 13 16",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgDeleteIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete-icon.c57d291c.svg";
export { ForwardRef as ReactComponent };